document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-copy-weekly]').forEach(button => {
    button.addEventListener('click', () => {
      try {
        const table = button.closest('table');
        const rows = Array.from(table.querySelectorAll('tr')).slice(1);
        const values = rows.map(row => {
          const cells = row.querySelectorAll('td');
          return cells.length >= 2 ? cells[cells.length - 1].textContent.trim() : null;
        }).filter(v => v !== null);

        navigator.clipboard.writeText(values.join('\n')).then(() => {
          alert('コピーしました！');
        }).catch(() => {
          alert('コピーに失敗しました。');
        });
      } catch (error) {
        alert('コピー処理中にエラーが発生しました。');
      }
    });
  });

  const copyButton = document.getElementById('copy-timecard-button');

  if (copyButton) {
    copyButton.addEventListener('click', () => {
      try {
        // --- ここからクリップボードコピー処理 ---

        // 1. コピー対象のテーブル要素を取得します。
        //    以前の実装と同様に、ページ内で最初に見つかったtable要素を対象とします。
        const table = document.querySelector("table");
        if (!table) {
          throw new Error('コピー対象のテーブルが見つかりませんでした。');
        }

        // 2. テーブルのすべての行（tr）を取得し、行ごとのデータ配列を作成します。
        let rows = Array.from(table.querySelectorAll("tr")).map(row => {
          // 3. 各行からすべてのセル（th, td）を取得し、セルのテキストを抽出します。
          const cells = Array.from(row.querySelectorAll("th, td")).map(cell => {
            // 各セルのテキストの前後の空白を削除し、ダブルクォーテーションで囲みます。
            return '"' + cell.textContent.trim() + '"';
          });

          // 以前の実装に倣い、各行の最後のセルを空欄（空のダブルクォーテーション）にします。
          // 不要な操作ボタン列などを除外するための処理と推測されます。
          if (cells.length > 0) {
            cells[cells.length - 1] = '""';
          }

          // 4. セルデータをタブ文字（\t）で連結し、1行分の文字列（TSV形式）を作成します。
          return cells.join("\t");
        });

        // 5. テーブル全体の行数が33行に満たない場合、最終行の１つ手前に空行を挿入します。
        //    これは給与計算ソフトなど、特定のフォーマットに合わせるための要件です。
        while (rows.length < 33) {
          // 配列の末尾から2番目の位置（最終行の1つ上）に空の行を追加します。
          rows.splice(rows.length - 1, 0, "");
        }

        // 6. 最終行（サマリー行）の不要な部分を整形します。
        //    以前の実装に倣い、先頭にある3つの空フィールドを削除します。
        if (rows.length > 0) {
          rows[rows.length - 1] = rows[rows.length - 1].replace(/^(""\t){3}/, "");
        }

        // 7. すべての行データを改行文字（\n）で連結し、最終的なテキストデータを作成します。
        const textToCopy = rows.join("\n");

        // 8. 作成したテキストをクリップボードに書き込みます。
        //    writeTextはPromiseを返すため、成功・失敗で処理を分岐します。
        navigator.clipboard.writeText(textToCopy).then(() => {
          // コピー成功時のメッセージ
          alert('コピーしました！');
        }).catch(err => {
          // コピー失敗時のメッセージ
          console.error('クリップボードへのコピーに失敗しました:', err);
          alert('コピーに失敗しました。');
        });

      } catch (error) {
        // 処理全体でエラーが発生した場合のメッセージ
        console.error('コピー処理中にエラーが発生しました:', error);
        alert('コピー処理中にエラーが発生しました。');
      }
    });
  }
});
